var map = {
	"./avatar_quero_bolsa.svg": 792,
	"./campaign/desktop/default.png": 545,
	"./campaign/desktop/modern.webp": 546,
	"./campaign/mobile/default.png": 547,
	"./campaign/mobile/modern.webp": 548,
	"./how-it-works-step-1.png": 232,
	"./how-it-works-step-2.png": 233,
	"./how-it-works-step-3.png": 234,
	"./icons/brands/folha.svg": 247,
	"./icons/brands/globo.svg": 245,
	"./icons/brands/veja.svg": 246,
	"./icons/brands/whatsapp.svg": 237,
	"./icons/breadcrumb/arrow-left.svg": 535,
	"./icons/breadcrumb/arrow-right.svg": 793,
	"./icons/i-arrow-down.svg": 209,
	"./icons/i-arrow-left-dark.svg": 287,
	"./icons/i-arrow-left.svg": 794,
	"./icons/i-arrow-up.svg": 690,
	"./icons/i-bars.svg": 795,
	"./icons/i-close.svg": 288,
	"./icons/i-info.svg": 235,
	"./icons/i-lifebuoy.svg": 236,
	"./icons/i-modal-close.png": 796,
	"./icons/i-profile.svg": 238,
	"./icons/i-qb-gray.svg": 797,
	"./icons/i-thumb-player.png": 798,
	"./icons/payments/amex@2x.png": 242,
	"./icons/payments/boleto@2x.png": 244,
	"./icons/payments/elo@2x.png": 243,
	"./icons/payments/master@2x.png": 241,
	"./icons/payments/trusted@2x.png": 239,
	"./icons/payments/visa@2x.png": 240,
	"./icons/social-networks/facebook.png": 697,
	"./icons/social-networks/facebook@2x.png": 799,
	"./icons/social-networks/facebook@3x.png": 800,
	"./icons/social-networks/twitter.png": 698,
	"./icons/social-networks/twitter@2x.png": 801,
	"./icons/social-networks/twitter@3x.png": 802,
	"./icons/social-networks/whatsapp.png": 699,
	"./icons/social-networks/whatsapp@2x.png": 803,
	"./icons/social-networks/whatsapp@3x.png": 804,
	"./illustrations/benino-3.0.png": 696,
	"./illustrations/benino-3.0@2x.png": 805,
	"./illustrations/benino-3.0@3x.png": 806,
	"./illustrations/benino.svg": 807,
	"./illustrations/form_filling.svg": 597,
	"./illustrations/localizacao.svg": 700,
	"./kuadro.png": 808,
	"./logo-anglo-dark.png": 809,
	"./logo-anglo.png": 810,
	"./premio_reclameaqui.svg": 248,
	"./quero.svg": 282,
	"./quero_bolsa.svg": 286,
	"./selo-politica@2x.png": 811
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 791;